/** Renders the active DialogStore request as a Dialog. Mount once at app root. */
import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {Button, TextField} from "@360crewing/ui";

import Dialog from "/components/ui/Dialog";
import DialogStore from "/stores/DialogStore";

const DialogHost: React.FC = observer(() => {
    const req = DialogStore.current;
    const [value, setValue] = useState("");

    useEffect(() => {
        setValue(req?.defaultValue ?? "");
    }, [req]);

    if (!req) return null;

    const cancel = (): void =>
        DialogStore.resolve(req.kind === "prompt" ? null : req.kind === "confirm" ? false : undefined);
    const confirm = (): void =>
        DialogStore.resolve(req.kind === "prompt" ? value : req.kind === "confirm" ? true : undefined);

    const footer = (
        <>
            {req.kind !== "alert" && (
                <Button variant="ghost" onClick={cancel}>{req.cancelLabel}</Button>
            )}
            <Button variant={req.danger ? "danger" : "primary"} onClick={confirm}>
                {req.confirmLabel}
            </Button>
        </>
    );

    return (
        <Dialog open title={req.title} onClose={cancel} footer={footer}>
            {req.message && <p className="dlg__message">{req.message}</p>}
            {req.kind === "prompt" && (
                <TextField size="md" value={value} onChange={setValue}
                           placeholder={req.placeholder} autoFocus/>
            )}
        </Dialog>
    );
});

export default DialogHost;
